import { useEffect } from "react";
import { getDocumentViewer } from "../../api/simpleSearchApi/simpleSearchApi";

import { useLocation, useParams } from "react-router-dom";
import LocalStorageUtil from "../../utils/localStorage";
const DocumentPreview: React.FC = () => {
  const { docstreamid } = useParams<{ docstreamid: string }>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fileName = searchParams.get("FileName");
  useEffect(() => {
    document.title =
      "DocDistro " + (fileName !== null ? " - FileName: " + fileName : "");
  }, []);

  useEffect(() => {
    const fetchDocumentViewer = async () => {
      const documentViewerRequestModel = {
        DocumentStreamId: docstreamid,
        contextName: LocalStorageUtil.getItem("contextName")?.toString(),
      };

      try {
        const documentViewerModelInfo = await getDocumentViewer(
          documentViewerRequestModel
        );
        if (documentViewerModelInfo) {
          const blob = b64toBlob(
            documentViewerModelInfo.base64FileStream,
            "application/pdf"
          );
          const blobUrl = URL.createObjectURL(blob);
          document.getElementById("pdfViewer")?.setAttribute("src", blobUrl);
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };
    fetchDocumentViewer();
  }, [docstreamid]);

  const b64toBlob = (b64Data: any, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  return (
    <iframe
      id="pdfViewer"
      title="Document PDF Viewer"
      style={{ width: "100%", height: "693px" }}
    ></iframe>
  );
};

export default DocumentPreview;
